import React from 'react';

const ImageIcon = ({ src, width }) => <img style={{ width: `${width}rem` }} src={src} alt={String(src)} />;

export default ImageIcon;
